import { fadeStyling } from "@made-people/blueprint-topbar/blueprint";

fadeStyling.main.override({
  slots: {
    wrapper:
      "relative px-component-spacing-sm md:px-component-spacing-lg lg:px-component-spacing-3xl",
    fade: "flex justify-center items-center overflow-hidden transition-all",
    item: "flex items-center justify-center py-2 w-full",
    label: "text-body-xs lg:text-body-sm w-full text-center truncate",
  },
  variants: {
    theme: {
      primary: { wrapper: "bg-surface-1 text-black" },
      secondary: { wrapper: "bg-red-550 text-white" },
      tertiary: { wrapper: "bg-plum-500 text-white" },
      black: { wrapper: "bg-black text-white" },
    },
  },
  defaultVariants: {
    theme: "primary",
  },
});
